module.exports = __webpack_public_path__ + "img/logo-dark.efeaed8c.png";